<template>
  <div>
    <div class="projet-part">
      <h2 id="ensemble">{{ $t("projet.inscription.vue-ensemble.titre") }}</h2>
      <InputWithValidation
        :model-value="projetAnnuel.projetPedagogique"
        :label="$t('projet.inscription.vue-ensemble.projet_pedagogique.question')"
        :input-notice="$t('projet.inscription.vue-ensemble.projet_pedagogique.info')"
        rules="required"
        vid="ensemble_0"
        :disabled="readonly"
        :validation-activated="validationActivated"
        :show-validation-errors="showValidationErrors"
        type="textarea"
        @update:model-value="updateProjetpedagogique"
        @manual-change="modified"
      />
      <br />
      <InputWithValidation
        :model-value="projetAnnuel.pitch"
        :label="$t('projet.inscription.vue-ensemble.presentation.question')"
        :input-notice="$t('projet.inscription.vue-ensemble.presentation.info')"
        rules="required"
        vid="ensemble_1"
        :disabled="readonly"
        :validation-activated="validationActivated"
        :show-validation-errors="showValidationErrors"
        type="textarea"
        @update:model-value="updatePitch"
        @manual-change="modified"
      />
      <RadioWithInputAndValidation
        :model-value="projetAnnuel.contexteReunionReferent"
        :label="$t('projet.inscription.vue-ensemble.reunions.question')"
        :data="booleanValue"
        :option-labels="booleanValueLabels"
        :validation-activated="validationActivated"
        :show-validation-errors="showValidationErrors"
        rules="required_boolean"
        vid="ensemble_2"
        :vertical-display="true"
        :disabled="readonly"
        @update:model-value="updateContextereunionreferent"
        @manual-change="modified"
      />
      <RadioWithInputAndValidation
        :model-value="projetAnnuel.contexteLienMairie"
        :label="$t('projet.inscription.vue-ensemble.mairie.question')"
        :data="booleanValue"
        :option-labels="booleanValueLabels"
        rules="required_boolean"
        vid="ensemble_3"
        :validation-activated="validationActivated"
        :show-validation-errors="showValidationErrors"
        :vertical-display="true"
        :disabled="readonly"
        @update:model-value="updateContextelienmairie"
        @manual-change="modified"
      />
      <ProjetAutresInfosView
        :projet-annuel="projetAnnuel"
        :readonly="readonly"
        :validation-activated="validationActivated"
        :show-validation-errors="showValidationErrors"
        :with-title="false"
        validation-group="ensemble"
        @dirtify-project="$emit('dirtify-project')"
        @projet-annuel-updated="updateProjetAutresInfos"
      />
      <div></div>
    </div>
  </div>
</template>

<script lang="ts">
import { ProjetAnnuelDTO, ProjetInscriptionDTO } from "@/model/bean/GeneratedDTOs"
import { defineComponent } from "vue"
import InputWithValidation from "@/views/inputs/InputWithValidation.vue"
import RadioWithInputAndValidation from "@/views/inputs/RadioWithInputAndValidation.vue"
import ProjetAutresInfosView from "@/pages/projet-page/info-administratives/ProjetAutresInfosView.vue"

export default defineComponent({
  name: "ProjetInscriptionVueEnsemble",
  components: {
    InputWithValidation,
    RadioWithInputAndValidation,
    ProjetAutresInfosView,
  },
  props: {
    projetAnnuel: {
      type: Object as () => ProjetInscriptionDTO,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    validationActivated: {
      type: Boolean,
      default: true,
    },
    showValidationErrors: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["dirtify-project", "projet-annuel-updated", "trigger-validation"],
  data() {
    return {
      booleanValue: [true, false],
    }
  },
  computed: {
    booleanValueLabels(): string[] {
      return this.booleanValue.map((value) => {
        return this.$t(`${value}`).toString()
      })
    },
  },
  methods: {
    updateContextelienmairie(newValue: any): void {
      const updatedProjetannuel = {
        ...this.projetAnnuel,
        contexteLienMairie: newValue,
      }
      this.updateProjetAnnuel(updatedProjetannuel)
    },
    updateContextereunionreferent(newValue: any): void {
      const updatedProjetannuel = {
        ...this.projetAnnuel,
        contexteReunionReferent: newValue,
      }
      this.updateProjetAnnuel(updatedProjetannuel)
    },
    updatePitch(newValue: any): void {
      const updatedProjetannuel = {
        ...this.projetAnnuel,
        pitch: newValue,
      }
      this.updateProjetAnnuel(updatedProjetannuel)
    },
    updateProjetpedagogique(newValue: any): void {
      const updatedProjetannuel = {
        ...this.projetAnnuel,
        projetPedagogique: newValue,
      }
      this.updateProjetAnnuel(updatedProjetannuel)
    },
    updateProjetAutresInfos(updatedProjetAnnuel: ProjetAnnuelDTO): void {
      this.updateProjetAnnuel(updatedProjetAnnuel)
    },

    updateProjetAnnuel(updatedProjetAnnuel: ProjetAnnuelDTO): void {
      this.modified()
      this.$emit("projet-annuel-updated", updatedProjetAnnuel)
    },

    modified(): void {
      this.$nextTick(() => {
        this.$emit("trigger-validation")
        this.$emit("dirtify-project")
      })
    },
  },
})
</script>
